export default __webpack_public_path__ + "static/painting5-e1d8db802e271d26c2c93bde7c44a546.jpg";